import { isAxiosError } from 'axios'
import { apiClient } from './client'
import type { ApiResponse } from './client'

export interface LmsPrintPdfCapability {
  enabled: boolean
  assetBaseUrl?: string
}

export interface LmsPrintPdfRequest {
  html: string
  fileName: string
  language: 'ko' | 'en'
}

export const lmsPrintPdfApi = {
  capability: async (): Promise<LmsPrintPdfCapability> => {
    const response = await apiClient.get<ApiResponse<LmsPrintPdfCapability>>('/lc/admin/print-pdf/capability')
    return response.data.data
  },
  download: async (request: LmsPrintPdfRequest) => {
    try {
      return await apiClient.post<Blob>('/lc/admin/print-pdf', request, {
        responseType: 'blob',
        timeout: 90_000,
      })
    } catch (error: unknown) {
      if (isAxiosError<unknown>(error) && error.response?.data instanceof Blob) {
        try {
          error.response.data = JSON.parse(await error.response.data.text()) as unknown
        } catch {
          // Proxies may return an HTML error body instead of the API envelope.
          error.response.data = null
        }
      }
      throw error
    }
  },
}

export function saveLmsPrintPdf(blob: Blob, contentDisposition: unknown, fallbackName: string) {
  const disposition = String(contentDisposition ?? '')
  const encodedName = /filename\*=UTF-8''([^;]+)/i.exec(disposition)?.[1]
  let fileName = /filename="([^"]+)"/i.exec(disposition)?.[1]
  if (encodedName) {
    try { fileName = decodeURIComponent(encodedName) } catch { fileName = undefined }
  }
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = (fileName ?? `${fallbackName.replace(/\.pdf$/i, '')}.pdf`).replace(/[\\/]|[^\u0020-\uffff]/g, '_')
  document.body.appendChild(link)
  link.click()
  link.remove()
  // Give mobile download managers time to consume the attachment.
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000)
}
